var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { Role } from '../Model';
import { rules } from 'helpers/Validation';
import { t, T } from 'helpers/i18n';
import { Form, Table } from 'components';
import { FieldType } from 'elements';
import { loading } from 'elements/Loading';
import { objectValues } from '../../../helpers/Utils';
import View from '../../../elements/View';
import Text from '../../../elements/Text';
import { toDateTime } from '../../../helpers/Format';
import { toParentPath } from '../../../helpers/History';
import { handleSubmit } from '../../../helpers/formHandleSubmit';
import { Button } from 'reactstrap';
var UserForm = /** @class */ (function (_super) {
    __extends(UserForm, _super);
    function UserForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sendEmail: true
        };
        _this.fields = __spreadArray([
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'lastname',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 6
            },
            {
                name: 'username',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'password',
                type: FieldType.Password,
                rules: rules()
                    .string()
                    .required(),
                size: 3
            },
            !_this.props.user || (_this.props.user && !_this.props.user.isVirtual) ?
                {
                    name: 'role',
                    type: FieldType.Select,
                    rules: rules()
                        .string()
                        .required(),
                    options: !_this.props.user ? objectValues(Role).filter(function (item) { return (item !== 'virtual'); }).map(function (value) { return ({ name: t(value), value: value }); })
                        : objectValues(Role).map(function (item) {
                            // console.log(item)
                            // options: ['super', 'admin', 'sel'].map(item => {
                            return { name: t(item), value: item };
                        }),
                    size: 4
                }
                :
                    {
                        name: 'role',
                        type: FieldType.Label,
                        rules: rules()
                            .string()
                            .required(),
                        size: 4
                    },
            {
                name: 'address',
                type: FieldType.Text,
                rules: rules().string(),
                size: 5
            },
            {
                name: 'zip',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                size: 2
            },
            {
                name: 'city',
                type: FieldType.Text,
                rules: rules().string(),
                size: 2
            },
            {
                name: 'province',
                type: FieldType.Text,
                rules: rules().string(),
                size: 2
            },
            {
                name: 'email',
                type: FieldType.Text,
                rules: rules().string(),
                size: 4
            },
            {
                name: 'phone',
                type: FieldType.Number,
                rules: rules()
                    .string(),
                size: 2
            }
        ], _this.props.store.users.user.isRetail ?
            [{
                    name: 'branch',
                    type: FieldType.Select,
                    rules: rules()
                        .number()
                        .integer()
                        .required(),
                    options: _this.props.branches.map(function (branch) {
                        return { name: branch.name, value: String(branch.id) };
                    }),
                    size: 4
                }]
            : [], true);
        return _this;
    }
    UserForm.prototype.render = function () {
        var _a = this.props, user = _a.user, logs = _a.logs;
        if (user)
            user.password = '********';
        var users = this.props.store.users;
        // console.log('user', user)
        var _logs = logs;
        if (logs) {
            _logs = logs.map(function (log) { return (__assign(__assign({}, log), { date: toDateTime(log.date), action: log.data.action })); });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Form, { loading: ['post@user/', 'put@user/'], fields: this.fields, values: user, store: users, sendIfIsCivitrip: true, handleSubmit: function (data) {
                    console.log('data: ', data);
                    handleSubmit(data).then(function (values) {
                        console.log('values', values);
                        toParentPath();
                    })
                        .catch(function (reason) {
                        console.log(reason);
                    });
                } }),
            React.createElement(Button, { onClick: function () {
                    // this.props.store.users.resetPassword()
                } }, T('resetPassword')),
            user && _logs && _logs.length > 0 &&
                React.createElement(View, { style: { margin: '25px' } },
                    React.createElement(Text, null, T('logs')),
                    React.createElement(Table, { keyExtractor: function (item) { return String(item.id); }, items: _logs, header: ['date', 'action',] }))));
    };
    UserForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.users.read(props.match.params.id).then(function (user) { return ({ user: user }); })
                : undefined,
            props.match.params.id
                ? props.store.logs.readLoginOut(props.match.params.id).then(function (logs) { return ({ logs: logs }); })
                : undefined
        ]; })
    ], UserForm);
    return UserForm;
}(Component));
export default UserForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/containers/UserForm.tsx
// module id = 1258
// module chunks = 0